import * as React from 'react';
import { cn } from '../utils';

export interface TableWrapperProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  isSidebarOpen?: boolean;
  /** When true, table is constrained to 100% of its container instead of viewport. Use when not using a sidebar. */
  constrainToContainer?: boolean;
}

export const TableWrapper = React.forwardRef<HTMLDivElement, TableWrapperProps>(
  (
    {
      className,
      children,
      isSidebarOpen = false,
      constrainToContainer = false,
      ...props
    },
    ref
  ) => (
    <div
      ref={ref}
      className={cn(
        'flex w-full transition-all duration-300',
        constrainToContainer
          ? 'max-w-full min-w-0'
          : [
              'max-w-[calc(100vw-3rem)]',
              isSidebarOpen && 'lg:max-w-[calc(100vw-304px)]',
            ],
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
);

TableWrapper.displayName = 'TableWrapper';
